import { gql } from "graphql-request";

export const GET_PRODUCTS_WITH_TARIFFS = gql`
  query GetProductsWithTariffs($query: ProductTariffQueryInput) {
    productsWithTariffs(query: $query) {
      data {
        _id
        sku
        name
        description
        htsCode
        countryOfOrigin
        metalPercentage
        metalBreakdown {
          steel
          aluminum
          copper
        }
        secondaryDutyRateString
        potentialFTAPrograms
        ftaApplicable
        ftaProgramCode
        ftaProgramName
        additionalTariffs {
          columnId
          columnName
          rate
        }
        totalDutyRate
        breakdownLines {
          lineType
          portion
          applicableRules {
            columnId
            columnName
            rate
          }
          totalRate
          exclusionsApplied {
            listId
            listName
            columnId
            columnName
            authority
            matchedCode
          }
          calculationBreakdown {
            columnId
            columnName
            isStackable
            mutuallyExclusiveGroup
            applied
          }
        }
        riskAnalysis {
          riskLevel
          riskReason
          analyzedAt
          analysisVersion
        }
        createdAt
        updatedAt
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;

export const CALCULATE_DUTIES = gql`
  query CalculateDuties($input: DutyCalculationInput!) {
    calculateDuties(input: $input) {
      additionalTariffs {
        columnId
        columnName
        rate
      }
      totalDutyRate
      # optional metadata if backend supplies it
      htsMatchedCode
      htsMatchLevel
      htsDescription
      secondaryDutyRateString
      potentialFTAPrograms
      ftaApplicable
      ftaProgramCode
      ftaProgramName
      breakdownLines {
        lineType
        portion
        applicableRules {
          columnId
          columnName
          rate
        }
        totalRate
        exclusionsApplied {
          listId
          listName
          columnId
          columnName
          authority
          matchedCode
        }
        calculationBreakdown {
          columnId
          columnName
          isStackable
          mutuallyExclusiveGroup
          applied
        }
      }
    }
  }
`;

export const GET_PRODUCTS = gql`
  query GetProducts($filter: ProductFilterInput) {
    products(filter: $filter) {
      data {
        _id
        sku
        name
        description
        htsCode
        countryOfOrigin
        metalPercentage
        metalBreakdown {
          steel
          aluminum
          copper
        }
        createdAt
        updatedAt
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;

export const CREATE_PRODUCT = gql`
  mutation CreateProduct($product: ProductInput) {
    createProduct(product: $product) {
      data {
        _id
        sku
        name
        description
        htsCode
        countryOfOrigin
        metalPercentage
        metalBreakdown {
          steel
          aluminum
          copper
        }
        clientId
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_PRODUCT = gql`
  mutation UpdateProduct($id: ID!, $product: ProductInput) {
    updateProduct(id: $id, product: $product) {
      data {
        _id
        sku
        name
        description
        htsCode
        countryOfOrigin
        metalPercentage
        metalBreakdown {
          steel
          aluminum
          copper
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const DELETE_PRODUCT = gql`
  mutation DeleteProduct($id: ID!) {
    deleteProduct(id: $id)
  }
`;

export const DELETE_PRODUCTS_BATCH = gql`
  mutation DeleteProductsBatch($ids: [ID!]!, $clientId: ID) {
    deleteProductsBatch(ids: $ids, clientId: $clientId) {
      success
      deletedCount
    }
  }
`;

export const CREATE_PRODUCTS_BATCH = gql`
  mutation CreateProductsBatch($input: BatchProductInput!) {
    createProductsBatch(input: $input) {
      success
      summary {
        totalRequested
        totalCreated
        totalFailed
      }
      createdProducts {
        _id
        sku
        name
        description
        htsCode
        countryOfOrigin
        metalPercentage
        createdAt
      }
      errors {
        index
        error
        product {
          sku
          name
          description
          htsCode
          countryOfOrigin
          metalPercentage
        }
      }
    }
  }
`; 